import { createActions } from "reduxsauce";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    paymentScheduleRequest: ["paymentScheduleId"],
    paymentScheduleRangeRequest: ["businessId", "startDate", "endDate", "options",],
    paymentScheduleSummaryRequest: ["businessId", "startDate", "endDate", "currentDate",],
    paymentScheduleProjectionRequest: ["businessId", "startDate", "endDate"],
    paymentScheduleAllRequest: ["options"],
    paymentScheduleUpdateRequest: ["paymentSchedule"],
    paymentScheduleDeleteRequest: ["paymentScheduleId"],
    paymentScheduleNotifyRequest: ["paymentScheduleId"],
    paymentScheduleCountRequest: ["params"],
    paymentScheduleFilteredRequest: ["filter", "options"],
    paymentScheduleFilteredCountRequest: ["filter"],
    markPaymentExternallyRequest: ["id", "receivedDate"],
    markPlanPaymentExternallyRequest: ["planId", "markPaidInfo"],
    paymentScheduleAllFilteredRequest: ["businessId", "params"],
    externalPaymentTotalsRequest: ["businessId", "query", "options"],
    paymentExternalCsvRequest: ["businessId", "query", "options"],
    paymentExternalPdfRequest: ["businessId", "membershipId", "query", "options"],

    paymentScheduleSuccess: ["paymentSchedule"],
    paymentScheduleRangeSuccess: ["paymentScheduleRange"],
    paymentScheduleSummarySuccess: ["paymentScheduleSummary"],
    paymentScheduleProjectionSuccess: ["projection"],
    paymentScheduleAllSuccess: ["paymentSchedules"],
    paymentScheduleUpdateSuccess: ["paymentSchedule"],
    paymentScheduleDeleteSuccess: [],
    paymentScheduleNotifySuccess: ["paymentSchedule"],
    paymentScheduleCountSuccess: ['count'],
    paymentScheduleFilteredSuccess: ["filtered"],
    paymentScheduleFilteredCountSuccess: ["filteredCount"],
    markPaymentExternallySuccess: [],
    markPlanPaymentExternallySuccess: [],
    paymentScheduleAllFilteredSuccess: ["filteredPaymentSchedule"],
    externalPaymentTotalsSuccess: ["externalPaymentTotals"],
    paymentExternalCsvSuccess: ["csv"],
    paymentExternalPdfSuccess: ["pdf"],

    paymentScheduleFailure: ["error"],
    paymentScheduleRangeFailure: ["error"],
    paymentScheduleSummaryFailure: ["error"],
    paymentScheduleProjectionFailure: ["error"],
    paymentScheduleAllFailure: ["error"],
    paymentScheduleUpdateFailure: ["error"],
    paymentScheduleDeleteFailure: ["error"],
    paymentScheduleNotifyFailure: ["error"],
    paymentScheduleCountFailure: ['error'],
    paymentScheduleFilteredFailure: ["error"],
    paymentScheduleFilteredCountFailure: ["error"],
    markPaymentExternallyFailure: ["error"],
    markPlanPaymentExternallyFailure: ["error"],
    paymentScheduleAllFilteredFailure: ["error"],
    externalPaymentTotalsFailure: ["error"],
    paymentExternalCsvFailure: ["error"],
    paymentExternalPdfFailure: ["error"],
});

export const PaymentScheduleTypes = Types;
export default Creators;